import isNil from 'lodash/isNil'

// NOTE: updateSortKey - updates sort key based on the order in the passed array, keeping untouched as many node as possible
// It's not trying to start all sequences from 0 and be consistent, the main concern is to have right order. So for example 100, 105, 500, 10000 is right sequence
export function updateSortKey<T extends { sortKey?: number | null }> (list: T[]): T[] {
  const sortedList: T[] = []

  for (let i = 0; i < list.length; i += 1) {
    const currentItem = list[i]
    const prevNode = i > 0 ? sortedList[i - 1] : null
    const prevNodeSortKey =
      isNil(prevNode) || isNil(prevNode.sortKey) ? Number.MIN_SAFE_INTEGER : prevNode.sortKey

    const currentItemSortKey = i === 0 ? (currentItem.sortKey ?? 0) : currentItem.sortKey

    const sortKey =
      isNil(currentItemSortKey) || currentItemSortKey <= prevNodeSortKey
        ? prevNodeSortKey + 1
        : currentItemSortKey

    sortedList.push({ ...currentItem, sortKey })
  }

  return sortedList
}
